import { call, fork, put, select, takeEvery } from "redux-saga/effects"
import * as fetchApi from "services/api/fetchApi"
import { globalUiAction } from "services/globalUi"
import * as scooterData from "views/constants/jsonData/scooterData"

import { scooterAction } from "./action"
import { getScooter } from "./selector"
import * as scooterUtil from "./util"

function* getFetchScooterData({ payload }) {
  try {
    if (payload.loading) {
      yield put(globalUiAction.setGlobalUI({ isLoading: true }))
    }

    const response =
      payload.method === "get"
        ? yield call(fetchApi.getDataByFetch, payload.url)
        : yield call(fetchApi.postDataByFetch, payload.url, payload.postData)

    if (response.data.Result === 1) {
      yield put(scooterAction.setScooterState({ [`${payload.name}`]: response.data.Data }))
    } else if (response.data.result === 1) {
      if (payload.name === "scooterProduct") {
        const scooterStore = yield select(getScooter)
        const [allAccessory, accessoryGroup] = scooterUtil.matchProducts(response.data.data, scooterStore)
        const comboAccessory = scooterUtil.matchComboProducts(response.data.data.ComboProduct)
        const stepMenu = scooterData.menuStep.filter((item) => {
          return (
            item.fitAllModel ||
            (item.code === "accessory" && allAccessory.length) ||
            (item.code === "combo" && comboAccessory.length)
          )
        })

        yield put(
          scooterAction.setScooterState({
            allAccessory,
            accessoryGroup,
            comboAccessory,
            stepMenu,
          }),
        )
      } else {
        const setData =
          payload.name === "wishData"
            ? JSON.parse(response.data.data.Config)
            : { [`${payload.name}`]: response.data.data }
        yield put(scooterAction.setScooterState(setData))
      }
    } else {
      throw {
        // eslint-disable-line no-throw-literal
        name: response.data.MessageCode,
        message: response.data.Message,
      }
    }
  } catch (error) {
    if (error?.response?.status === 401) {
      return window.location.reload()
    }
    yield put(
      globalUiAction.openErrorModal({
        title: "Initial failed",
        content: `${error.name}, ${error.message}`,
      }),
    )
  } finally {
    if (payload.loading) {
      yield put(globalUiAction.setGlobalUI({ isLoading: false }))
    }
  }
}

function* addAccToCart({ payload }) {
  const scooterStore = yield select(getScooter)
  const newArr = [...scooterStore.allAccessory]

  newArr.map((obj) => {
    if (obj.ProductId === payload.id) {
      obj._selected = 1

      if (obj.Color.length > 1) {
        obj.Color.filter((colorObj) => colorObj._code === payload.color)[0]._selected = 1
      } else {
        obj.Color[0]._selected = 1
      }
    }
    return obj
  })

  yield put(scooterAction.setScooterState({ allAccessory: newArr }))
}

function* removeAccFromCart({ payload }) {
  const scooterStore = yield select(getScooter)
  const newArr = [...scooterStore.allAccessory]

  newArr.map((obj) => {
    if (obj.ProductId === payload) {
      obj._selected = 0

      obj.Color.forEach((colorObj) => (colorObj._selected = 0))
    }
    return obj
  })

  yield put(scooterAction.setScooterState({ allAccessory: newArr }))
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchFetchScooterData() {
  yield takeEvery(scooterAction.FETCH_SCOOTER_DATA, getFetchScooterData)
}

export function* watchAddAccToCart() {
  yield takeEvery(scooterAction.ADD_ACCESSORY_TO_CART, addAccToCart)
}

export function* watchRemoveAccFromCart() {
  yield takeEvery(scooterAction.REMOVE_ACCESSORY_FROM_CART, removeAccFromCart)
}

//=====================================
//  ROOT
//-------------------------------------

export const scooterSaga = [fork(watchFetchScooterData), fork(watchAddAccToCart), fork(watchRemoveAccFromCart)]
